import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=2330f9ee&scoped=true"
import script from "./AddDialog.vue?vue&type=script&lang=js"
export * from "./AddDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=2330f9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330f9ee",
  null
  
)

export default component.exports